import { ERROR } from "../constants/types/alertType";
import { NOTIFICATION_RECEIVED } from "../constants/types/dashboardType";
import axios from "../utils/axios";
import { setUserSubscription, setPractitionerStatus } from "../utils/helper";

export const getPatientNotification = (roleId) => (dispatch) => {
  if (roleId > 0) {
    roleId = roleId == 3 ? roleId : roleId == 4 ? roleId : 1;
    axios.get(`notificationsPatient?roleId=${roleId}`).then(
      (resp) => {
        dispatch({
          type: NOTIFICATION_RECEIVED,
          payload: resp?.data,
        });
        setUserSubscription(
          resp?.data?.notification.subscription
            ? resp.data.notification.subscription
            : 0
        );
        setPractitionerStatus(resp?.data?.notification.prac_status);
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to get Notification",
        });
      }
    );
  }
};
